import { Field } from "formik";
import { FtextField } from "../../../../../components/common/FtextField";
import { useTranslation } from "react-i18next";

const UddoktaPayForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="displayGrid3">
        <FtextField
          type="text"
          label={t("apiKey")}
          name="settings.paymentGateway.uddoktapay.apiKey"
          validation={true}
        />

        <FtextField
          type="text"
          label={t("url")}
          name="settings.paymentGateway.uddoktapay.apiUrl"
          validation={true}
        />
      </div>

      <div className="displayGrid3">
        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="uddoktaPay"
            name="settings.paymentGateway.providers.uddoktaPay"
          />
          <label className="form-check-label" for="uddoktaPay">
            {t("hasGateway")} <span className="text-danger ms-1">*</span>
          </label>
        </div>

        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="hasPG"
            name="settings.paymentGateway.hasPG"
          />
          <label className="form-check-label" for="hasPG">
            {t("hasPG")} <span className="text-danger me-4">*</span>
          </label>
        </div>
      </div>
    </>
  );
};

export default UddoktaPayForm;
